<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records doctor-list">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body profile-details bg-white border-radius-5">
                            <div class="row no-gutters">
                                <div class="col-md-3">
                                    <figure class="mb-3"><img src="../../../../static/website/images/Profile-pic.svg" alt="" /></figure>
                                    <router-link to="/calendy-calendar" class="btn btn-link btn-blue Profile-Appointment mt-2">Book an Appointment</router-link>
                                </div>
                                <div class="col-md-9 pl-4">
                                    <h2>Dr. Shabnam Das Kar, MD, FMNM</h2>
                                    <h5>Specialist in Functional and Metabolic Medicine</h5>
                                    <h6><a href="#">Urinalysis</a> | 8 year Exp</h6>
                                    <div class="dr-info mt-4 mb-0 row no-gutters">
                                        <div class="col-md-6 pr-3 pl-3 d-flex mb-5 align-items-center">
                                            <i class="icon icon-graduation-cap"></i>
                                            <div>
                                                <h3>Education</h3>
                                                <p>MBBS, MD (Skin, VD and Leprosy)</p>
                                            </div>
                                        </div>

                                        <div class="col-md-6 pr-3 pl-3 d-flex mb-5 align-items-center">
                                            <i class="icon icon-map-macker"></i>
                                            <div>
                                                <h3>Location</h3>
                                                <p>TORONTO 18 York St ON, Canada M5J 2T8</p>
                                            </div>
                                        </div>

                                        <div class="col-md-6 pr-3 pl-3 d-flex mb-5 align-items-center">
                                            <i class="icon icon-domain-registration"></i>
                                            <div>
                                                <h3>Registration Number</h3>
                                                <p>13999/2000</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 pr-3 pl-3 d-flex mb-5 align-items-center">
                                            <i class="icon icon-translate"></i>
                                            <div>
                                                <h3>Languages</h3>
                                                <p>English, Hindi</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h4 class="mt-4">About Dr. Shabnam Das Kar</h4>
                                <p class="pb-3">
                                    Dr. Shabnam Das Kar is a Urinalysis and Leprologist at Gini Healthcare Canada. He has 10 years of experience in his field. He has done his MBBS and MD (Skin and VD) from Sriram Chandra Bhanj
                                    Medical College, Cuttack (1999 and 2006 respectively). Some of the services he provides are Hair Loss Treatment, Anti Aging Treatment, Dermatosurgery, Medical Vitiligo Treatment and Muscle
                                    Relaxing Injections.
                                </p>
                                <h4>Professional Memberships</h4>
                                <p class="pb-3">Life time Member of Indian Association of Dermatologist, Venereologist and Leprologist (since 2004)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Doctor-profile-detail",
        data() {
            return {};
        },
        created(){
           this.pageName('Profile')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/doctor/doctor-profile.vue